import { useNavigate } from "react-router-dom";
import { LockKeyhole, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/LOGO AZUL OSCURO.png";

// Pantalla a pantalla completa (sin sidebar) que ve un alumno cuyo periodo de
// acceso al programa ha finalizado o ha sido retirado. Solo se muestra cuando
// el gate de acceso en Layout detecta has_active_access() === false.
export default function AccessExpired() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    navigate("/", { replace: true });
    await signOut();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-navy via-navy-light to-slate-800 relative overflow-hidden px-6">
      <div className="absolute -top-1/2 -right-1/5 w-4/5 h-[200%] bg-[radial-gradient(circle,rgba(108,200,196,0.06)_0%,transparent_70%)] pointer-events-none" />

      <div className="w-full max-w-md relative z-10">
        <div className="flex justify-center mb-8">
          <img
            src={logo}
            alt="Entrena Tu Centro"
            className="h-16 brightness-0 invert"
          />
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-2xl shadow-black/30 text-center">
          <div className="w-14 h-14 rounded-full bg-brand/10 flex items-center justify-center mx-auto mb-5">
            <LockKeyhole size={26} className="text-brand" />
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Tu acceso ha finalizado
          </h1>
          <p className="text-sm text-gray-500 leading-relaxed mb-8">
            El periodo de acceso al programa ha terminado. Si crees que se trata
            de un error o quieres reactivar tu acceso, ponte en contacto con tu
            responsable del programa.
          </p>

          <button
            onClick={handleLogout}
            className="w-full py-3 bg-brand hover:bg-brand-dark text-white rounded-xl text-sm font-semibold transition-all hover:-translate-y-0.5 hover:shadow-lg hover:shadow-brand/30 flex items-center justify-center gap-2"
          >
            <LogOut size={16} />
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
}
